import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';

import DegreeDesktopMainNav from 'bundles/composable-page-header-degree/main-nav-modules/desktop/DegreeDesktopMainNav';
import DegreeMobileMainNav from 'bundles/composable-page-header-degree/main-nav-modules/mobile/DegreeMobileMainNav';
import DefaultDegreePageHeaderProvider from 'bundles/composable-page-header-degree/providers/DefaultDegreePageHeaderProvider';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const DegreePageHeader = () => {
  return (
    <GlobalPageHeaderContainer desktopMainNav={<DegreeDesktopMainNav />} mobileMainNav={<DegreeMobileMainNav />} />
  );
};

const DegreePageHeaderWithProvider = () => {
  return (
    <StatsigProvider>
      <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={undefined}>
        <DefaultDegreePageHeaderProvider>
          <DegreePageHeader />
        </DefaultDegreePageHeaderProvider>
      </GlobalPageHeaderStateProvider>
    </StatsigProvider>
  );
};

export default DegreePageHeaderWithProvider;
